import { z } from 'zod';

// ============================================================================
// Phase 5 Domain 5.1 Feature 1: Conflict Schemas
//
// Centralized conflict schemas consumed by both calendar-items.types.ts
// (CalendarItem union) and event-instances/schemas.ts (EventInstanceDetail).
// ============================================================================

// === Enum Schemas ===

/** Conflict source type — mirrors Prisma ConflictSourceType enum */
export const conflictSourceTypeSchema = z.enum([
  'CALENDAR_EVENT',
  'MANUAL_BLOCK',
  'EXTERNAL_EVENT',
  'BUFFER',
]);

/** Conflict lifecycle status — mirrors Prisma ConflictStatus enum */
export const conflictStatusSchema = z.enum(['ACTIVE', 'RESOLVED']);

// === DTO Schemas ===

/**
 * Conflict blocker summary.
 * Used in:
 * - 409 CONFLICTS_DETECTED response payload (blockers array)
 * - CalendarItem.primaryConflict field
 */
export const conflictBlockerSchema = z.object({
  kind: conflictSourceTypeSchema,
  sourceId: z.string(),
  label: z.string(),
  startsAt: z.string().datetime(),
  endsAt: z.string().datetime(),
});

/**
 * Full conflict detail for EventInstanceDetail.conflicts array.
 * Includes lifecycle fields (id, status) beyond the blocker summary.
 */
export const conflictDetailSchema = z.object({
  id: z.string(),
  sourceType: conflictSourceTypeSchema,
  sourceId: z.string(),
  sourceAnchorType: z.enum(['SESSION', 'EVENT', 'BLOCK']).nullable(),
  label: z.string(),
  startsAt: z.string().datetime(),
  endsAt: z.string().datetime(),
  status: conflictStatusSchema,
});

/**
 * 409 CONFLICTS_DETECTED response payload.
 * Returned when publishMode='live' is requested but conflicts exist.
 * No instance is created — the client retries with publishMode='draft'.
 */
export const conflictsDetectedResponseSchema = z.object({
  error: z.literal('CONFLICTS_DETECTED'),
  blockers: z.array(conflictBlockerSchema),
});
